var _path, _path2, _path3, _path4, _path5, _path6, _path7, _g, _g2, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSlide1Cabin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2560,
    height: 900,
    viewBox: "0 0 2560 900",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.000152588 735.123V900H2560V735.623H1756.34L1697.28 821.26H868.3L800.573 734.079L0.000152588 735.123Z",
    fill: "#1D2264"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.000152588 735.123V900H2560V735.623H1756.34L1697.28 821.26H868.3L800.573 734.079L0.000152588 735.123Z",
    fill: "url(#paint0_linear_7722_44551)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M795.591 735.622L0.000152588 735.621V716.498L857.506 716.499L795.591 735.622Z",
    fill: "url(#paint1_linear_7722_44551)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1769.87 735.623H2560V716.5L1704.04 716.5L1769.87 735.623Z",
    fill: "url(#paint2_linear_7722_44551)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1704.04 829.456H862.013L918.947 778.145H1642.48L1704.04 829.456Z",
    fill: "url(#paint3_linear_7722_44551)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M795.591 735.623L862.013 829.456L918.947 778.145L857.506 716.5L795.591 735.623Z",
    fill: "url(#paint4_linear_7722_44551)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1704.04 716.5L1642.48 778.145L1704.04 829.456L1769.87 735.623L1704.04 716.5Z",
    fill: "url(#paint5_linear_7722_44551)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1281.42 749.046H923.454L876.958 702.129L876.84 701.654L724.661 211.94L726.322 211.346C726.915 211.108 782.306 191.748 878.026 172.625C966.273 155.046 1108.01 134.022 1281.54 134.022V137.586C1108.37 137.586 966.866 158.49 878.738 176.188C792.27 193.411 738.895 210.871 729.05 214.196L880.042 700.347L924.877 745.601H1281.42V749.046Z",
    fill: "url(#paint6_linear_7722_44551)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1639.39 749.044H1281.42V745.48H1637.97L1682.8 700.227L1833.68 214.076C1823.95 210.75 1770.46 193.29 1683.99 176.067C1595.86 158.489 1454.48 137.465 1281.19 137.465V133.902C1454.71 133.902 1596.46 154.925 1684.7 172.504C1780.42 191.627 1835.81 210.988 1836.41 211.225L1838.07 211.819L1837.59 213.482L1685.89 702.127L1639.39 749.044Z",
    fill: "url(#paint7_linear_7722_44551)"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1866.06 197.567C1714.12 143.405 1508.8 109.554 1279.88 109.554C1050.96 109.554 845.764 143.762 693.822 197.924L0.000152588 37V53.7432L693.467 204.1L837.342 716.5H856.557L697.025 202.793C848.729 149.344 1052.74 117.275 1279.88 117.275C1507.02 117.275 1711.15 149.344 1862.86 202.793L1704.04 716.5H1724.32L1866.42 203.981L2560 53.7437V37.0004L1866.06 197.567Z",
    fill: "url(#paint8_linear_7722_44551)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M697.025 202.796L857.506 716.503L851.694 716.384L695.839 201.964L697.025 202.796Z",
    fill: "url(#paint9_linear_7722_44551)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M837.342 716.5L774.715 735.623H795.591L857.506 716.5H837.342Z",
    fill: "url(#paint10_linear_7722_44551)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1724.32 716.5L1790.86 735.623H1769.87L1704.15 716.5H1724.32Z",
    fill: "url(#paint11_linear_7722_44551)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M837.342 716.5H0.000152588V718.757L835.207 717.094L837.342 716.5Z",
    fill: "url(#paint12_linear_7722_44551)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M857.507 716.5L918.947 778.145L916.219 780.52L851.695 718.282L857.507 716.5Z",
    fill: "url(#paint13_linear_7722_44551)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M918.947 778.145H1096.86L1096.51 780.52H916.219L918.947 778.145Z",
    fill: "url(#paint14_linear_7722_44551)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M1704.15 716.5L1642.6 778.145L1645.32 780.52L1709.85 718.282L1704.15 716.5Z",
    fill: "url(#paint15_linear_7722_44551)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M1642.6 778.145H1454.83L1455.07 780.52H1645.32L1642.6 778.145Z",
    fill: "url(#paint16_linear_7722_44551)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1093.07 780.519L1066.03 829.455H1086.55L1093.07 780.519Z",
    fill: "url(#paint17_linear_7722_44551)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1460.76 780.519L1487.69 829.455H1467.17L1460.76 780.519Z",
    fill: "url(#paint18_linear_7722_44551)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M0.000152588 53.7446L693.467 203.979L694.06 203.266L0.000152588 49.5874V53.7446Z",
    fill: "url(#paint19_linear_7722_44551)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M693.466 203.981L837.342 716.5H839.358L694.059 203.268L693.466 203.981Z",
    fill: "url(#paint20_linear_7722_44551)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M1862.86 202.795L1704.04 716.502H1710.68L1864.04 201.607L1862.86 202.795Z",
    fill: "url(#paint21_linear_7722_44551)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M2560 53.7409L1866.42 203.978L1865.94 203.266L2560 48.1885V53.7409Z",
    fill: "url(#paint22_linear_7722_44551)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1866.42 203.981L1724.32 716.5H1722.18L1865.94 203.268L1866.42 203.981Z",
    fill: "url(#paint23_linear_7722_44551)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M1279.88 114.307C1052.03 114.307 847.661 148.277 695.839 201.963C696.194 202.201 697.143 202.795 697.143 202.795C848.847 149.346 1052.86 117.276 1280 117.276C1506.43 117.276 1711.39 149.702 1862.98 202.795C1863.21 202.557 1863.81 201.963 1864.16 201.607C1712.22 147.92 1507.62 114.307 1279.88 114.307Z",
    fill: "url(#paint24_linear_7722_44551)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M790.49 722.557C790.49 723.745 787.762 724.814 783.374 725.527C780.764 725.883 777.68 726.121 774.241 726.121C770.801 726.121 767.717 725.883 765.108 725.527C760.838 724.933 757.991 723.864 757.991 722.557C757.991 721.37 760.719 720.301 765.108 719.588C767.717 719.232 770.801 718.994 774.241 718.994C777.562 718.994 780.764 719.232 783.374 719.588C787.644 720.301 790.49 721.251 790.49 722.557Z",
    fill: "#121B2E"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M774.359 726.122C777.799 726.122 780.883 725.885 783.492 725.528C786.339 725.053 788.474 724.459 789.66 723.747C788.474 723.034 786.339 722.44 783.492 721.965C780.883 721.609 777.799 721.371 774.359 721.371C770.919 721.371 767.836 721.609 765.226 721.965C762.379 722.321 760.126 723.034 759.058 723.747C760.244 724.459 762.379 725.053 765.226 725.528C767.836 725.885 770.919 726.122 774.359 726.122Z",
    fill: "#F4B840"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M774.359 696.783C769.377 696.783 765.226 700.821 765.226 705.928V723.864C765.226 724.22 769.259 724.933 774.359 724.933C779.341 724.933 783.492 724.339 783.492 723.864V705.928C783.492 700.94 779.341 696.783 774.359 696.783Z",
    fill: "url(#paint25_linear_7722_44551)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M719.917 722.557C719.917 723.745 717.188 724.814 712.8 725.527C710.19 725.883 707.106 726.121 703.667 726.121C700.227 726.121 697.143 725.883 694.534 725.527C690.264 724.933 687.417 723.864 687.417 722.557C687.417 721.37 690.145 720.301 694.534 719.588C697.143 719.232 700.227 718.994 703.667 718.994C706.988 718.994 710.19 719.232 712.8 719.588C717.07 720.301 719.917 721.251 719.917 722.557Z",
    fill: "#121B2E"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M703.785 726.122C707.225 726.122 710.309 725.885 712.918 725.528C715.765 725.053 717.9 724.459 719.086 723.747C717.9 723.034 715.765 722.44 712.918 721.965C710.309 721.609 707.225 721.371 703.785 721.371C700.346 721.371 697.262 721.609 694.652 721.965C691.806 722.321 689.552 723.034 688.484 723.747C689.671 724.459 691.806 725.053 694.652 725.528C697.262 725.885 700.346 726.122 703.785 726.122Z",
    fill: "#283D7E"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M703.785 696.783C698.804 696.783 694.652 700.821 694.652 705.928V723.864C694.652 724.22 698.685 724.933 703.785 724.933C708.767 724.933 712.918 724.339 712.918 723.864V705.928C712.918 700.94 708.767 696.783 703.785 696.783Z",
    fill: "#262757"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M774.359 718.994C770.208 718.994 765.582 714.362 765.226 709.492V723.864C765.226 724.22 769.259 724.933 774.359 724.933C779.341 724.933 783.492 724.339 783.492 723.864V709.492C782.899 715.312 779.815 718.994 774.359 718.994Z",
    fill: "#1A1E51"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M779.934 699.158C779.934 699.871 777.325 699.515 774.359 699.515C771.394 699.515 769.022 699.633 769.022 698.921C769.022 698.208 771.394 696.783 774.359 696.783C777.325 696.783 779.934 698.446 779.934 699.158Z",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M699.871 697.734C701.057 697.14 702.362 696.902 703.785 696.902C708.767 696.902 712.918 700.941 712.918 706.048V723.983C712.799 724.458 709.478 724.696 709.478 724.696C709.478 714.125 711.02 703.673 707.581 700.109C705.09 697.496 701.769 697.259 699.871 697.734Z",
    fill: "url(#paint26_linear_7722_44551)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M942.433 789.43C941.365 790.618 937.214 791.687 933.062 791.687C928.911 791.687 926.539 790.737 927.606 789.43C928.674 788.243 932.825 787.292 936.976 787.292C941.128 787.173 943.5 788.124 942.433 789.43Z",
    fill: "#262757"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M976 789.43C975.051 790.618 971.018 791.687 966.867 791.687C962.715 791.687 960.224 790.737 961.173 789.43C962.122 788.243 966.155 787.292 970.306 787.292C974.221 787.173 976.83 788.124 976 789.43Z",
    fill: "#262757"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M1009.57 789.43C1008.85 790.618 1004.82 791.687 1000.67 791.687C996.519 791.687 993.791 790.737 994.621 789.43C995.451 788.243 999.366 787.292 1003.52 787.292C1007.55 787.173 1010.28 788.124 1009.57 789.43Z",
    fill: "#262757"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M1043.37 789.43C1042.78 790.618 1038.98 791.687 1034.71 791.687C1030.56 791.687 1027.71 790.737 1028.31 789.43C1028.9 788.243 1032.81 787.292 1036.85 787.292C1041.12 787.173 1043.96 788.124 1043.37 789.43Z",
    fill: "#262757"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M935.197 797.863C934.129 799.169 929.741 800.238 925.471 800.238C921.201 800.238 918.71 799.169 919.896 797.863C921.082 796.556 925.352 795.487 929.622 795.487C933.773 795.487 936.383 796.556 935.197 797.863Z",
    fill: "#262757"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M969.713 797.863C968.764 799.169 964.494 800.238 960.224 800.238C955.954 800.238 953.344 799.169 954.412 797.863C955.479 796.556 959.631 795.487 963.782 795.487C968.052 795.487 970.661 796.556 969.713 797.863Z",
    fill: "#262757"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M1004.47 797.863C1003.64 799.169 999.603 800.238 995.214 800.238C990.944 800.238 988.216 799.169 989.046 797.863C989.877 796.556 994.028 795.487 998.18 795.487C1002.45 795.487 1005.3 796.556 1004.47 797.863Z",
    fill: "#262757"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M1039.34 797.863C1038.74 799.169 1034.71 800.238 1030.44 800.238C1026.17 800.238 1023.21 799.169 1023.92 797.863C1024.63 796.556 1028.54 795.487 1032.81 795.487C1036.97 795.606 1039.93 796.556 1039.34 797.863Z",
    fill: "#262757"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M927.487 806.89C926.301 808.316 921.794 809.385 917.405 809.385C913.017 809.385 910.526 808.197 911.712 806.89C913.017 805.465 917.524 804.396 921.794 804.396C926.064 804.396 928.673 805.465 927.487 806.89Z",
    fill: "#262757"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M963.189 806.89C962.122 808.316 957.733 809.385 953.345 809.385C948.956 809.385 946.228 808.197 947.414 806.89C948.482 805.465 952.87 804.396 957.259 804.396C961.41 804.396 964.138 805.465 963.189 806.89Z",
    fill: "url(#paint27_linear_7722_44551)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M999.01 806.89C998.18 808.316 993.91 809.385 989.403 809.385C985.014 809.385 982.168 808.197 983.116 806.89C984.065 805.465 988.335 804.396 992.605 804.396C996.994 804.396 999.841 805.584 999.01 806.89Z",
    fill: "#262757"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M1034.95 807.01C1034.24 808.436 1030.09 809.505 1025.7 809.505C1021.31 809.505 1018.22 808.317 1019.06 807.01C1019.77 805.585 1023.92 804.516 1028.31 804.516C1032.58 804.516 1035.66 805.585 1034.95 807.01Z",
    fill: "#262757"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M919.185 816.511C917.88 818.055 913.135 819.243 908.628 819.243C904.121 819.243 901.511 818.055 902.935 816.511C904.24 815.086 908.984 813.898 913.373 813.898C917.88 813.779 920.489 814.967 919.185 816.511Z",
    fill: "#262757"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M956.073 816.51C955.005 818.054 950.38 819.242 945.872 819.242C941.365 819.242 938.637 818.054 939.705 816.51C940.891 815.085 945.398 813.897 949.905 813.897C954.412 813.897 957.14 815.085 956.073 816.51Z",
    fill: "#262757"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M993.198 816.631C992.249 818.175 987.861 819.362 983.235 819.362C978.609 819.362 975.762 818.175 976.711 816.631C977.66 815.205 982.167 814.017 986.556 814.017C991.063 813.899 994.029 815.086 993.198 816.631Z",
    fill: "#262757"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M1030.32 816.63C1029.61 818.174 1025.34 819.362 1020.72 819.362C1016.09 819.362 1013.01 818.174 1013.84 816.63C1014.67 815.205 1018.94 814.017 1023.44 814.017C1027.95 814.017 1031.04 815.205 1030.32 816.63Z",
    fill: "#262757"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M1612.71 789.43C1613.77 790.618 1617.92 791.687 1622.08 791.687C1626.23 791.687 1628.6 790.737 1627.53 789.43C1626.46 788.243 1622.31 787.292 1618.16 787.292C1614.13 787.173 1611.64 788.124 1612.71 789.43Z",
    fill: "#262757"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M1579.26 789.43C1580.21 790.618 1584.24 791.687 1588.39 791.687C1592.54 791.687 1595.03 790.737 1594.08 789.43C1593.13 788.243 1589.1 787.292 1584.95 787.292C1580.92 787.173 1578.31 788.124 1579.26 789.43Z",
    fill: "#262757"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M1545.57 789.43C1546.28 790.618 1550.32 791.687 1554.47 791.687C1558.62 791.687 1561.35 790.737 1560.52 789.43C1559.69 788.243 1555.77 787.292 1551.62 787.292C1547.59 787.173 1544.86 788.124 1545.57 789.43Z",
    fill: "#262757"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M1511.89 789.43C1512.48 790.618 1516.27 791.687 1520.54 791.687C1524.7 791.687 1527.54 790.737 1526.95 789.43C1526.36 788.243 1522.44 787.292 1518.41 787.292C1514.14 787.173 1511.29 788.124 1511.89 789.43Z",
    fill: "#262757"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M1619.94 797.863C1621.01 799.169 1625.4 800.238 1629.67 800.238C1633.94 800.238 1636.43 799.169 1635.24 797.863C1634.06 796.556 1629.79 795.487 1625.52 795.487C1621.36 795.487 1618.87 796.556 1619.94 797.863Z",
    fill: "#262757"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M1585.42 797.863C1586.37 799.169 1590.64 800.238 1594.91 800.238C1599.18 800.238 1601.79 799.169 1600.73 797.863C1599.66 796.556 1595.51 795.487 1591.36 795.487C1587.09 795.487 1584.48 796.556 1585.42 797.863Z",
    fill: "#262757"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M1550.79 797.863C1551.62 799.169 1555.65 800.238 1560.04 800.238C1564.31 800.238 1567.04 799.169 1566.21 797.863C1565.38 796.556 1561.23 795.487 1557.08 795.487C1552.81 795.487 1549.96 796.556 1550.79 797.863Z",
    fill: "#262757"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M1515.92 797.863C1516.51 799.169 1520.54 800.238 1524.81 800.238C1529.08 800.238 1532.05 799.169 1531.34 797.863C1530.63 796.556 1526.71 795.487 1522.44 795.487C1518.17 795.606 1515.33 796.556 1515.92 797.863Z",
    fill: "url(#paint28_linear_7722_44551)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M1627.77 806.89C1628.95 808.316 1633.46 809.385 1637.85 809.385C1642.24 809.385 1644.73 808.197 1643.54 806.89C1642.24 805.465 1637.73 804.396 1633.46 804.396C1629.07 804.396 1626.58 805.465 1627.77 806.89Z",
    fill: "#262757"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M1592.07 806.89C1593.13 808.316 1597.52 809.385 1601.91 809.385C1606.3 809.385 1609.03 808.197 1607.84 806.89C1606.77 805.465 1602.39 804.396 1598 804.396C1593.73 804.396 1591 805.465 1592.07 806.89Z",
    fill: "#262757"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M1556.25 806.89C1557.08 808.316 1561.35 809.385 1565.85 809.385C1570.24 809.385 1573.09 808.197 1572.14 806.89C1571.19 805.465 1566.92 804.396 1562.65 804.396C1558.26 804.396 1555.42 805.584 1556.25 806.89Z",
    fill: "#262757"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M1520.19 807.01C1520.9 808.436 1525.05 809.505 1529.44 809.505C1533.83 809.505 1536.91 808.317 1536.08 807.01C1535.37 805.585 1531.22 804.516 1526.83 804.516C1522.56 804.516 1519.6 805.585 1520.19 807.01Z",
    fill: "#262757"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M1635.95 816.511C1637.26 818.055 1642 819.243 1646.51 819.243C1651.02 819.243 1653.63 818.055 1652.2 816.511C1650.9 815.086 1646.15 813.898 1641.77 813.898C1637.38 813.779 1634.77 814.967 1635.95 816.511Z",
    fill: "#262757"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M1599.07 816.51C1600.13 818.054 1604.76 819.242 1609.27 819.242C1613.77 819.242 1616.5 818.054 1615.43 816.51C1614.25 815.085 1609.74 813.897 1605.23 813.897C1600.84 813.897 1598 815.085 1599.07 816.51Z",
    fill: "url(#paint29_linear_7722_44551)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M1562.06 816.631C1563.01 818.175 1567.4 819.362 1572.02 819.362C1576.65 819.362 1579.49 818.175 1578.55 816.631C1577.6 815.205 1573.09 814.017 1568.7 814.017C1564.07 813.899 1561.23 815.086 1562.06 816.631Z",
    fill: "#262757"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M1524.81 816.63C1525.53 818.174 1529.8 819.362 1534.42 819.362C1539.05 819.362 1542.13 818.174 1541.3 816.63C1540.47 815.205 1536.2 814.017 1531.69 814.017C1527.19 814.017 1524.1 815.205 1524.81 816.63Z",
    fill: "#262757"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1442.97 717.212H1107.3V724.695H1442.97V717.212Z",
    fill: "white"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M1173.01 867.109L1135.29 839.91L840.07 627.419H1726.93L1433.36 840.86L1397.19 867.228L1173.01 867.109Z",
    fill: "url(#paint30_linear_7722_44551)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M1462.66 876.373H1093.54C1083.46 876.373 1078.6 867.464 1079.78 861.526L1102.68 722.082C1103.15 719.351 1107.18 716.5 1110.39 716.5H1443.45C1446.65 716.5 1450.33 719.232 1450.8 721.964L1474.17 863.782C1474.64 866.989 1474.17 876.373 1462.66 876.373Z",
    fill: "url(#paint31_linear_7722_44551)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M1464.2 869.4H1089.63C1085.83 869.4 1082.99 866.431 1083.46 863.105L1105.18 724.732C1105.53 722.605 1108.26 720.586 1111.34 719.981H1442.49C1445.41 719.981 1448.3 722.001 1448.66 724.732L1470.37 863.105C1470.85 866.431 1468 869.4 1464.2 869.4Z",
    fill: "url(#paint32_linear_7722_44551)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M1085.6 848.851C1085.6 848.851 1231.49 831.51 1313.92 786.969C1396.36 742.428 1409.52 720.208 1409.52 720.208H1446.28C1447.71 720.208 1448.92 721.253 1449.13 722.664L1470.01 863.819C1470.43 866.715 1468.19 869.315 1465.26 869.315H1088.05C1085.12 869.315 1082.87 866.699 1083.31 863.797L1085.6 848.851Z",
    fill: "url(#paint33_linear_7722_44551)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M1724.32 716.5L2560 716.5V718.757L1726.45 717.094L1724.32 716.5Z",
    fill: "url(#paint34_linear_7722_44551)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M1827.51 722.557C1827.51 723.745 1824.78 724.814 1820.39 725.527C1817.78 725.883 1814.7 726.121 1811.26 726.121C1807.82 726.121 1804.74 725.883 1802.13 725.527C1797.86 724.933 1795.01 723.864 1795.01 722.557C1795.01 721.37 1797.74 720.301 1802.13 719.588C1804.74 719.232 1807.82 718.994 1811.26 718.994C1814.58 718.994 1817.78 719.232 1820.39 719.588C1824.66 720.301 1827.51 721.251 1827.51 722.557Z",
    fill: "#121B2E"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M1811.38 726.122C1814.82 726.122 1817.9 725.885 1820.51 725.528C1823.36 725.053 1825.49 724.459 1826.68 723.747C1825.49 723.034 1823.36 722.44 1820.51 721.965C1817.9 721.609 1814.82 721.371 1811.38 721.371C1807.94 721.371 1804.86 721.609 1802.25 721.965C1799.4 722.321 1797.15 723.034 1796.08 723.747C1797.26 724.459 1799.4 725.053 1802.25 725.528C1804.86 725.885 1807.94 726.122 1811.38 726.122Z",
    fill: "#F4B840"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M1811.38 696.783C1806.4 696.783 1802.25 700.821 1802.25 705.928V723.864C1802.25 724.22 1806.28 724.933 1811.38 724.933C1816.48 724.933 1820.51 724.339 1820.51 723.864V705.928C1820.51 700.94 1816.36 696.783 1811.38 696.783Z",
    fill: "url(#paint35_linear_7722_44551)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M1898.08 722.557C1898.08 723.745 1895.36 724.814 1890.97 725.527C1888.36 725.883 1885.27 726.121 1881.83 726.121C1878.39 726.121 1875.31 725.883 1872.7 725.527C1868.43 724.933 1865.58 723.864 1865.58 722.557C1865.58 721.37 1868.31 720.301 1872.7 719.588C1875.31 719.232 1878.39 718.994 1881.83 718.994C1885.16 718.994 1888.36 719.232 1890.97 719.588C1895.36 720.301 1898.08 721.251 1898.08 722.557Z",
    fill: "#121B2E"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M1881.95 726.122C1885.39 726.122 1888.48 725.885 1891.09 725.528C1893.93 725.053 1896.07 724.459 1897.25 723.747C1896.07 723.034 1893.93 722.44 1891.09 721.965C1888.48 721.609 1885.39 721.371 1881.95 721.371C1878.51 721.371 1875.43 721.609 1872.82 721.965C1869.97 722.321 1867.72 723.034 1866.65 723.747C1867.84 724.459 1869.97 725.053 1872.82 725.528C1875.43 725.885 1878.51 726.122 1881.95 726.122Z",
    fill: "#283D7E"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M1881.95 696.783C1876.97 696.783 1872.82 700.821 1872.82 705.928V723.864C1872.82 724.22 1876.85 724.933 1881.95 724.933C1887.05 724.933 1891.09 724.339 1891.09 723.864V705.928C1891.09 700.94 1887.05 696.783 1881.95 696.783Z",
    fill: "#262757"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1811.38 718.994C1807.23 718.994 1802.6 714.362 1802.25 709.492V723.864C1802.25 724.22 1806.28 724.933 1811.38 724.933C1816.48 724.933 1820.51 724.339 1820.51 723.864V709.492C1819.92 715.312 1816.72 718.994 1811.38 718.994Z",
    fill: "#1A1E51"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1816.95 699.158C1816.95 699.871 1814.34 699.515 1811.38 699.515C1808.41 699.515 1806.04 699.633 1806.04 698.921C1806.04 698.208 1808.41 696.783 1811.38 696.783C1814.23 696.783 1816.95 698.446 1816.95 699.158Z",
    fill: "white"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M1885.87 697.734C1884.68 697.14 1883.38 696.902 1881.95 696.902C1876.97 696.902 1872.82 700.941 1872.82 706.048V723.983C1872.94 724.458 1876.26 724.696 1876.26 724.696C1876.26 714.125 1874.72 703.673 1878.16 700.109C1880.65 697.496 1883.97 697.259 1885.87 697.734Z",
    fill: "url(#paint36_linear_7722_44551)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7722_44551",
    x1: 1280,
    y1: 735.22,
    x2: 1280,
    y2: 901.451,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B0F3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8542,
    stopColor: "#0B0F3C",
    stopOpacity: 0.1458
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B0F3C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7722_44551",
    x1: 695.305,
    y1: 715.407,
    x2: 695.305,
    y2: 727.675,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#569DD3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#344A9D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_7722_44551",
    x1: 1865.47,
    y1: 715.409,
    x2: 1865.47,
    y2: 727.677,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#569DD3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#344A9D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_7722_44551",
    x1: 1283.02,
    y1: 775.197,
    x2: 1283.02,
    y2: 808.103,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#569DD3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#344A9D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_7722_44551",
    x1: 821.696,
    y1: 786.671,
    x2: 895.286,
    y2: 744.001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#344A9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#569DD3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_7722_44551",
    x1: 1774.37,
    y1: 754.039,
    x2: 1633.19,
    y2: 791.949,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#344A9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#569DD3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_7722_44551",
    x1: 724.707,
    y1: 441.534,
    x2: 1281.54,
    y2: 441.534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#99D5D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#232A83"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_7722_44551",
    x1: 1838.14,
    y1: 441.532,
    x2: 1281.3,
    y2: 441.532,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#99D5D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#232A83"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_7722_44551",
    x1: 1280,
    y1: 75.1733,
    x2: 1280,
    y2: 463.957,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE0A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2781,
    stopColor: "#99D5D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5594,
    stopColor: "#7AD2E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_7722_44551",
    x1: 776.672,
    y1: 172.787,
    x2: 776.672,
    y2: 502.374,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4406,
    stopColor: "#7AD2E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7219,
    stopColor: "#99D5D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE0A2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_7722_44551",
    x1: 816.111,
    y1: 715.409,
    x2: 816.111,
    y2: 727.677,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B0F3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8542,
    stopColor: "#0B0F3C",
    stopOpacity: 0.1458
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B0F3C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_7722_44551",
    x1: 1747.51,
    y1: 715.409,
    x2: 1747.51,
    y2: 727.677,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B0F3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8542,
    stopColor: "#0B0F3C",
    stopOpacity: 0.1458
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B0F3C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_7722_44551",
    x1: 685.223,
    y1: 716.369,
    x2: 685.223,
    y2: 717.796,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE0A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2781,
    stopColor: "#99D5D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5594,
    stopColor: "#7AD2E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_7722_44551",
    x1: 885.321,
    y1: 712.861,
    x2: 885.321,
    y2: 753.905,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE0A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2781,
    stopColor: "#99D5D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5594,
    stopColor: "#7AD2E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_7722_44551",
    x1: 914.917,
    y1: 779.332,
    x2: 1098.82,
    y2: 779.332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4406,
    stopColor: "#7AD2E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7219,
    stopColor: "#99D5D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE0A2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_7722_44551",
    x1: 1676.22,
    y1: 712.861,
    x2: 1676.22,
    y2: 753.905,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE0A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2781,
    stopColor: "#99D5D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5594,
    stopColor: "#7AD2E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_7722_44551",
    x1: 1646.74,
    y1: 779.332,
    x2: 1452.69,
    y2: 779.332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4406,
    stopColor: "#7AD2E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7219,
    stopColor: "#99D5D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE0A2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_7722_44551",
    x1: 1065.87,
    y1: 804.987,
    x2: 1093.32,
    y2: 804.987,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B0F3C",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1458,
    stopColor: "#0B0F3C",
    stopOpacity: 0.1458
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B0F3C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_7722_44551",
    x1: 1487.89,
    y1: 804.987,
    x2: 1460.44,
    y2: 804.987,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B0F3C",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1458,
    stopColor: "#0B0F3C",
    stopOpacity: 0.1458
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B0F3C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_7722_44551",
    x1: 531.906,
    y1: 172.8,
    x2: 695.841,
    y2: 172.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B0F3C",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1458,
    stopColor: "#0B0F3C",
    stopOpacity: 0.1458
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B0F3C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_7722_44551",
    x1: 692.427,
    y1: 459.884,
    x2: 840.973,
    y2: 459.884,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B0F3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8542,
    stopColor: "#0B0F3C",
    stopOpacity: 0.1458
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B0F3C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_7722_44551",
    x1: 1784.04,
    y1: 172.393,
    x2: 1784.04,
    y2: 502.218,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4406,
    stopColor: "#7AD2E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7219,
    stopColor: "#99D5D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE0A2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_7722_44551",
    x1: 2028.08,
    y1: 172.796,
    x2: 1864.14,
    y2: 172.796,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B0F3C",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1458,
    stopColor: "#0B0F3C",
    stopOpacity: 0.1458
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B0F3C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_7722_44551",
    x1: 1867.54,
    y1: 459.884,
    x2: 1720.65,
    y2: 459.884,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B0F3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8542,
    stopColor: "#0B0F3C",
    stopOpacity: 0.1458
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B0F3C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_7722_44551",
    x1: 1280,
    y1: 109.342,
    x2: 1280,
    y2: 165.967,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4406,
    stopColor: "#7AD2E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7219,
    stopColor: "#99D5D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE0A2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_7722_44551",
    x1: 774.359,
    y1: 696.817,
    x2: 774.359,
    y2: 725.153,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9C25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_7722_44551",
    x1: 715.655,
    y1: 705.403,
    x2: 708.633,
    y2: 709.552,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9C25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCE7C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_7722_44551",
    x1: 947.082,
    y1: 806.89,
    x2: 963.365,
    y2: 806.89,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9C25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_7722_44551",
    x1: 1515.82,
    y1: 797.863,
    x2: 1531.47,
    y2: 797.863,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9C25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_7722_44551",
    x1: 1598.88,
    y1: 816.569,
    x2: 1615.75,
    y2: 816.569,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9C25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_7722_44551",
    x1: 1283.5,
    y1: 865.081,
    x2: 1283.5,
    y2: 621.948,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9C25",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3132,
    stopColor: "#FFAE44",
    stopOpacity: 0.3434
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7654,
    stopColor: "#FFC56D",
    stopOpacity: 0.1173
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCE7C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_7722_44551",
    x1: 1276.95,
    y1: 715.01,
    x2: 1276.95,
    y2: 876.203,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#569DD3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#344A9D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_7722_44551",
    x1: 1276.92,
    y1: 720.826,
    x2: 1276.92,
    y2: 869.355,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9C25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_7722_44551",
    x1: 1276.86,
    y1: 869.711,
    x2: 1276.86,
    y2: 716.914,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9C25",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3132,
    stopColor: "#FFAE44",
    stopOpacity: 0.3434
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7654,
    stopColor: "#FFC56D",
    stopOpacity: 0.1173
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCE7C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_7722_44551",
    x1: 1875.61,
    y1: 716.369,
    x2: 1875.61,
    y2: 717.796,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE0A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2781,
    stopColor: "#99D5D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5594,
    stopColor: "#7AD2E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_7722_44551",
    x1: 1811.38,
    y1: 696.817,
    x2: 1811.38,
    y2: 725.153,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9C25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_7722_44551",
    x1: 1872.23,
    y1: 708.392,
    x2: 1878.16,
    y2: 710.465,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9C25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCE7C",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlide1Cabin);
export default __webpack_public_path__ + "static/media/slide_1_cabin.bb9cd369cb61d6cf6dbd13edc4ae6074.svg";
export { ForwardRef as ReactComponent };